import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type AppSettingState = {
  language: string
}

const initialState: AppSettingState = {
  language: '',
}

export const appSettingsSlice = createSlice({
  name: 'appSettings',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload
    },
  },
})

export const { setLanguage } = appSettingsSlice.actions

export default appSettingsSlice.reducer
